import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

import { AddLoanProductButton } from './AddLoanProductButton';
import { EditLoanProductButton } from './EditLoanProductButton';

export type Implementation = {
  id: string;
  name: string;
  slug: string;
  loanProducts: Array<{
    id: string;
    name: string;
    slug: string;
  }>;
  borrowerOrganization: {
    id: string;
    name: string;
    slug: string;
  };
  ownerOrganization: {
    id: string;
    name: string;
    slug: string;
  };
};

export type LoanProduct = {
  id: string;
  name: string;
  slug: string;
};

export interface LoanProductsTableProps {
  implementation: Implementation;
}

// Exports
export const LoanProductsTable = ({
  implementation,
}: LoanProductsTableProps) => {
  return (
    <Box mb="35px">
      <Flex justifyContent="space-between" padding="25px 0px">
        <Heading display="inline-block" fontSize="3xl" as="h3">
          Loan Products
        </Heading>
        <AddLoanProductButton implementation={implementation} />
      </Flex>
      <Table>
        <Thead>
          <Tr>
            <Th>Id</Th>
            <Th>Name</Th>
            <Th>Slug</Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {implementation.loanProducts.map((loanProduct) => (
            <Tr key={loanProduct.id}>
              <Td>{loanProduct.id}</Td>
              <Td>{loanProduct.name}</Td>
              <Td>{loanProduct.slug}</Td>
              <Td>
                <EditLoanProductButton
                  implementation={implementation}
                  loanProductDetails={{
                    id: loanProduct.id,
                    name: loanProduct.name,
                  }}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {implementation.loanProducts.length === 0 && (
        <Alert>
          <AlertIcon />
          <AlertDescription>No loan products configured</AlertDescription>
        </Alert>
      )}
    </Box>
  );
};
